import React from 'react'
import {SvgIcon} from 'rambler-ui'

export default function SberbankIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        fill="#21a038"
        d="m10 9.8 7.1-5.2c.4.4.7.9.9 1.4l.1.3-8.2 6-3.4-2.1V7.6L10 9.8zm6.9 0v.2c0 3.8-3.1 6.9-6.9 6.9S3.1 13.8 3.1 10c0-3.8 3.1-6.9 6.9-6.9 1.4 0 2.8.4 3.9 1.2L15.6 3l-.2-.2c-4-3-9.6-2.2-12.6 1.7S.6 14.1 4.5 17.1s9.6 2.2 12.6-1.7C18.4 13.9 19 12 19 10c0-.5 0-1.1-.1-1.6l-2 1.4zM0 20V0m20 20V0"
      />
    </SvgIcon>
  )
}
